import * as React from 'react';
import type { SVGProps } from 'react';

const IconLockWithCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" {...props}>
    <circle cx="9.88" cy="10.44" r="9.505" fill="currentColor" />
    <path
      fill="currentColor"
      stroke="currentStroke"
      d="M5.938 9.892a1 1 0 0 1 1-1h5.884a1 1 0 0 1 1 1v3.844a1 1 0 0 1-1 1H6.938a1 1 0 0 1-1-1V9.892ZM7.977 7.713a1.903 1.903 0 1 1 3.806 0v1.179H7.977v-1.18Z"
    />
  </svg>
);
export default IconLockWithCircle;
